// extracted by mini-css-extract-plugin
export var searchHeader = "_40-0";
export var searchHeaderDark = "_40-1";